/**
 * Register a new customer in Klaviyo with language
 * @author Lina Arroyo <lina.arroyo@gradiweb.com>
 */

import { registerEmailInKlaviyo } from '../services/klaviyo';
import { $Q } from '../utils/querySelector';
import { currentLangNow } from '../utils/getLanguage';
import { registerDateInKlaviyo } from './updatecustomer';

export const createCustomerWithLang = async () => {
  let email = $Q('#RegisterForm-email').value;
  let lang = currentLangNow();
  const inputDate = $Q('#RegisterForm-Birthdate');
  await registerEmailInKlaviyo(email, lang);

  if (inputDate.value && email) {
    await registerDateInKlaviyo(email, inputDate.value);
  }
};
